import React, { useState} from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import agent from "../api/agent";
import TagManager from "react-gtm-module";

const PaypalPayment = ({paypalClientId, invoiceId, invoiceAmount, packageId, redirectUrl, disabled = false}) => {
  const [message, setMessage] = useState('')

  const createPaypalOrder = async () => {
    if (disabled) {
      return
    }
    try {
      setMessage('')
      const requestBody = {
        invoiceId: invoiceId
      }

      const orderResp = await agent.checkout.startPaypal(requestBody)
      const orderId = orderResp.data.data.id

      return orderId

    } catch (e) {
      setMessage(`Could not initiate PayPal Checkout...${e.message}`)
    }
  }

  const onApprove = async (data, actions) => {
    try {
      setMessage('')
      await agent.checkout.paypalCheckout({orderId: data.orderID, invoiceId: invoiceId.toString()})
      actions.redirect(redirectUrl)

      const tagManagerArgs = {
        dataLayer: {
          event: 'purchase',
          transaction_id: invoiceId,
          value: invoiceAmount,
          items: [
            {
              item_id: packageId,
              item_name: `Shipment for ${packageId}`,
              affiliation: `ship.reship.com`,
              price: invoiceAmount,
              quantity: 1
            }
          ],
          currency: 'USD'
        },
        dataLayerName: 'dataLayer'
      }

      TagManager.dataLayer(tagManagerArgs)

    } catch (e) {
      const errorIssue = e.response.data.message?.issues
      if (errorIssue?.length && errorIssue[0].issue === "INSTRUMENT_DECLINED") {
        return actions.restart();
      } else if (errorIssue?.length && errorIssue[0].issue) {
        setMessage(errorIssue[0].description)
      } else {
        setMessage( e.response.data.message.message || e.response.data.message?.error_description)
      }
    }
  }

  const initialOptions = {
    clientId: paypalClientId,
    intent: "capture",
    currency: "USD",
    "enable-funding": "paypal",
    "data-sdk-integration-source": "integrationbuilder_sc",
  }

  return (<div className="pt-3">
      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          disabled={disabled}
          style={{
            shape: "rect",
            layout: "horizontal",
            color: "gold",
            disableMaxWidth: true,
            height: 52,
            tagline: false
          }}
          createOrder={createPaypalOrder}
          onApprove={onApprove}
        />
      </PayPalScriptProvider>
      {message && <div className="error-text">{message}</div>}
    </div>
  )

}

export default PaypalPayment